module.exports = __webpack_public_path__ + "media/demo-video.ff514ec4.mp4";